import { render } from "./AuthorsTable.vue?vue&type=template&id=54f7e8ae"
import script from "./AuthorsTable.vue?vue&type=script&lang=js"
export * from "./AuthorsTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apple/Desktop/projects/Active Projects/EIEV/Media Dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__